import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgWellbeing = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ jsxs("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.45312 0.526581H14.5469C15.3467 0.526581 16 1.19272 15.9971 2.01181V14.9903C15.9971 15.8062 15.3467 16.4724 14.5439 16.4724H1.45312C0.65332 16.4724 0 15.8095 0 14.9903V2.00864C0 1.19272 0.65332 0.526581 1.45312 0.526581ZM8 14.6206H14V2.38156H8V14.6206Z" })
] });
const ForwardRef = /* @__PURE__ */ forwardRef(SvgWellbeing);
export { ForwardRef as ReactComponent };
import assetUrl from "/home/runner/work/UpstriveEducation-Teacher/UpstriveEducation-Teacher/src/assets/svg/wellbeing.svg?url";
export default assetUrl;
